import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchKPIPeople } from "redux/KPIs/KPIPeopleSlice";
import Select from "react-select";

import { createKPIBonusPeople, updateKPIBonusPeople } from "components/Apis/KPIs";
import toast from "react-hot-toast"; // Import toast for error notifications


const ContinuousImprovement = () => {
    const quarter = useSelector((state) => state.KPIFilterReducer.quarter);
    const KPIPeople = useSelector((state) => state.KPINeoBonusCalculatorPeopleReducer.KPIPeople);
    const [refresh, setRefresh] = useState(false);

    const dispatch = useDispatch();

    useEffect(() => {
        if (quarter) {
            dispatch(fetchKPIPeople({ ...quarter }));
        }
    }, [quarter, dispatch, refresh]);

    if (!(KPIPeople && KPIPeople.length > 0)) {
        return <h3
            style={{ display: "flex", "justifyContent": "center" }}
        >
            Members not created yet...
        </h3>;
    }

    // Columns to keep
    const COLUMNS_TO_KEEP = [
        "name",
        "continuous_improvement_completed",
    ];

    // Filter headers to include only columns in COLUMNS_TO_KEEP
    const headers = KPIPeople ? Object.keys(KPIPeople[0]).filter(key => COLUMNS_TO_KEEP.includes(key)) : [];

    // Format headers: replace underscores with spaces and capitalize the first letter of each word
    const formattedHeaders = headers.map(header =>
        header
            .replace(/_/g, ' ') // Replace all underscores with spaces
            .replace(/\b\w/g, char => char.toUpperCase()) // Capitalize the first letter of each word
    );

    const updateBonusPersonData = async (record) => {
        try {
            const response = await updateKPIBonusPeople(record);
            if (response) {
                setRefresh(!refresh);
                toast.success("Data updated successfully!");
            } else {
                toast.error("Error updating data");
            }
        } catch (error) {
            if (error.response.status === 403) {
                toast.error(error.response.data);
            }
            else {
                toast.error("Failed to update data. Please try again.");
            }
        }
    };

    return (
        <>
            <table className="kpis-goals-table thin continuous-improvement-table">
                <thead>
                    <tr>
                        {formattedHeaders.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {KPIPeople?.map((person, index) => (
                        <tr key={index}>
                            <td>
                                <div>
                                    {person.name}
                                </div>
                            </td>
                            <td>
                                <div className={`select-container ${person.continuous_improvement_completed}`}>
                                    <Select
                                        options={['Yes', 'No', 'N/A'].map((option) => ({
                                            value: option, // `value` is what will be stored
                                            label: option, // `label` is what will be displayed
                                        }))}
                                        placeholder="Empty select"
                                        onChange={(selectedOptions) => {
                                            updateBonusPersonData({
                                                id: person.id,
                                                continuous_improvement_completed: selectedOptions.value, // For single-select, extract the single value
                                            });
                                        }}
                                        defaultValue={() => {
                                            const value = person.continuous_improvement_completed;
                                            if (!value) {
                                                return null;
                                            }
                                            return {
                                                value: value, label: value
                                            }
                                        }}
                                        className="select-dropdown"
                                        classNamePrefix="react-select"
                                        menuPortalTarget={document.body} // Render dropdown in document.body
                                        styles={{
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        }}
                                    />
                                    <div className="icon-container"></div>
                                </div>
                            </td>
                        </tr>
                    ))}
                    {/* <tr>
                        <td colSpan={headers.length} style={{ textAlign: 'center' }}>
                            <button
                                className="new-row-btn"
                                onClick={() => {
                                    createKPIBonusPeople(quarter);
                                    setTimeout(() => {
                                        setRefresh(!refresh);
                                    }, 300);
                                }}
                            >
                                <div className="sign">+</div>
                                <div className="text">Add New Team</div>
                            </button>
                        </td>
                    </tr> */}
                </tbody>
            </table>
        </>
    );
};

export default ContinuousImprovement;